<template>
  <div class="bg-white loginBox">
    <phone
      class="margin20-bottom"
      @phoneEmit="phoneEmit"
      :placeholder="phonePholder"
    ></phone>
    <verification-code
      @codeEmit="codeEmit"
      class="margin20-bottom"
    ></verification-code>
    <div class="padding15-top" @click="btnClick">
      <btn :btnCol="btnColor" :btnText="btnText"></btn>
    </div>
    <div class="text-right padding15-top gray-8 ft14">
      <span @click="goRegister">免费注册</span>
    </div>
    <toast ref="toast"></toast>
  </div>
</template>

<script>
import Phone from "@/components/input/phone";
import VerificationCode from "@/components/input/verificationCode";
import Btn from "@/components/input/button";
import Toast from "@/components/toast/tosatInfo";
import { loginCode } from "@/model/user/userServe";
import { CacheModule } from "@/utils/commonUtils.js";
import { mutations } from "@/observable/store";

export default {
  name: "noteLogin",
  data() {
    return {
      phonePholder: "请输入手机号",
      btnText: "登录",
      phoneObj: {},
      btnColor: false,
      codeObj: {},
    };
  },
  components: {
    Phone,
    VerificationCode,
    Btn,
    Toast,
  },
  watch: {
    phoneObj(val) {
      if (val.name && this.codeObj.name) {
        this.btnColor = true;
      }
    },
    codeObj(val) {
      if (val.name && this.phoneObj.name) {
        this.btnColor = true;
      }
    },
  },
  methods: {
    phoneEmit(e) {
      this.phoneObj = e;
    },
    codeEmit(e) {
      this.codeObj = e;
    },
    btnClick() {
      if (this.phoneObj && !this.phoneObj.phoneFlag) {
        // this.$refs.toast.showToast("请输入正确的手机号");
        return;
      }
      if (this.codeObj && !this.codeObj.codeFlag) {
        this.$refs.toast.showToast("验证码格式有误");
        return;
      }

      let params = {
        loginname: this.phoneObj.name, //登录手机号
        code: this.codeObj.name, //登录密码
      };

      loginCode(params)
        .then((data) => {
          CacheModule.set("loginPhone", this.phoneObj.name);
          CacheModule.set("setToken", data.data.token);
          mutations.getToken(data.data.token);
          if (this.$route.query.pathLogin) {
            this.$router.push({
              path: this.$route.query.pathLogin,
            });
          } else {
            this.$router.push({
              path: "/",
            });
          }
        })
        .catch((error) => {
          this.$refs.toast.showToast(error.message);
        });
    },
    goRegister() {
      this.$router.push({
        path: "/register",
        query: {
          pathLogin: this.$route.query.pathLogin,
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.loginBox {
  width: 100%;
  box-sizing: border-box;
  padding: 1rem 0.75rem 0;
}
</style>
